$(document).on('submit','.djJs-form-default',function(e){

    try {
        var form = $(this);
        var buttons = form.find('button');

        buttons.each(function() {
            $(this).enableLoadingAnimation(true);
        });
    }
    catch (e) {}

    return true;
});
